import React from "react";
import { usePostHog } from "posthog-js/react";

const RouterErrorBoundary = () => {
  const posthog = usePostHog();

  React.useEffect(() => {
    if (window.newrelic) {
      window.newrelic.noticeError(new Error("Router error boundary triggered"));
    }

    if (posthog) {
      posthog.capture("router_error_boundary_triggered", {
        path: window.location?.pathname,
      });
    }
  }, [posthog]);

  return (
    <div className="w-full flex flex-col items-center gap-3 p-8" role="alert">
      <h2 className="text-2xl font-bold text-gray-800">
        Something went wrong.
      </h2>
      <p className="text-gray-600 text-center max-w-md">
        If the problem continues please reach out to us on{" "}
        <a
          href="mailto:support@ontik.io"
          className="text-blue-600 hover:underline"
        >
          support@ontik.io
        </a>
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-1 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors cursor-pointer"
      >
        Try again
      </button>
    </div>
  );
};

export default RouterErrorBoundary;
